// Shared status config used across Admin, Driver, and Tracking pages
export const TRIP_STATUSES = ['Pending', 'Pickup Started', 'In Transit', 'Near Destination', 'Delivered'];

export const STATUS_STYLES = {
  'Pending':          'text-yellow-400 bg-yellow-400/10 border-yellow-400/20',
  'Pickup Started':   'text-blue-400 bg-blue-400/10 border-blue-400/20',
  'In Transit':       'text-brand-orange bg-brand-orange/10 border-brand-orange/20',
  'Near Destination': 'text-purple-400 bg-purple-400/10 border-purple-400/20',
  'Delivered':        'text-green-400 bg-green-400/10 border-green-400/20',
};

export const TRUCK_TYPES = ['Dost Plus', 'Bada Dost', '17 Feet', '19 Feet', '20 Feet', '22 Feet', '24 Feet', '32 Feet', 'Eicher 2059'];

export const MATERIAL_TYPES = ['Electronics', 'Furniture', 'FMCG', 'Machinery', 'Textiles', 'Chemicals', 'Food & Beverages', 'Construction Material', 'Automotive Parts', 'Other'];

export const PAYMENT_STATUSES = ['Pending', 'Partial', 'Paid'];

export const ADMIN_EMAIL = 'pkroutexadmin@gmail.com';

export const CONTACT_PHONE_DISPLAY = '+91 86087 98890';
export const CONTACT_PHONE_TEL = '+918608798890';
export const WHATSAPP_NUMBER = '918608798890';
export const CONTACT_EMAIL = 'hdines52@gmail.com';
export const CONTACT_ADDRESS = 'Gugai Arumuga Nagar, Erumapalayam Main Road, Salem 636015';

export const WHATSAPP_LINK = (message = '') => {
  const suffix = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${WHATSAPP_NUMBER}${suffix}`;
};

export const generateTrackingId = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  return 'PKX' + Array.from({ length: 7 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
};
